<div class="container">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    @for (link of navLinks(); track link.path) {
    <a
      mat-tab-link
      [routerLink]="link.path"
      routerLinkActive
      #rla="routerLinkActive"
      [active]="rla.isActive"
      [disabled]="link.disabled"
    >
      {{ link.label | translate }}
    </a>
    }
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <ng-content></ng-content>
  </mat-tab-nav-panel>
</div>